import styled, { keyframes } from 'styled-components'

const fadeUp = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

export const ModalBackground = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  overflow-y: scroll;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: ${({ theme }) => theme.colors.backgroundOverlay};
  animation: ${fadeUp} 324ms forwards;
`

export const CloseButton = styled.div`
  position: absolute;
  right: 3.5rem;
  top: 3.5rem;
  cursor: pointer;
  z-index: 20;
`

export const VideoPlayer = styled.div`
  width: calc(100vw - 4rem);
  height: calc(100vh - 4rem);
  display: flex;
  justify-content: center;
  align-items: center;
`
